import { RootState } from '../store';

export const pastLocationSelector = (state: RootState) =>
  state.locationHistory.pastLocations;

export const previousLocationSelector = (state: RootState) =>
  state.locationHistory.previousLocation;
